<template>
  <div class="edit-create-title-box">
    <div class="title-row">
      <h2 class="title-text">{{ label }}</h2>
      <div class="title-actions">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditCreateTitleBox",
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/global/colors.scss";

.edit-create-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
  padding: 0 8px 0 4px;
  background: transparent;
  height: 40px;
}

.title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.title-text {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: $gray-90;
}

.title-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}
</style>
